import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
export function reducer(state, action) {
  switch (action.type) {
    case 'END_EXPERIENCE':
      // When the experience ends the plugin state needs to reset everything back to the initial plugin state
      return _objectSpread({
        modalDecorationSet: DecorationSet.empty,
        dispatchAnalyticsEvent: state.dispatchAnalyticsEvent
      }, action.data);
    case 'SHOW_MODAL':
      return _objectSpread(_objectSpread({}, state), action.data);
    default:
      return state;
  }
}